module.exports = __webpack_public_path__ + "static/sanfranciscodisplay-bold-webfont-e5c73589dd152ab41e24e17e76eda535.woff";